
const checkboxFooter = document.querySelector('#terms-suscription');
const buttonSubmit = document.querySelector('#newsletter-submit');
const contactForm = document.querySelector('#contact_form');
const formNewsletter = document.querySelector('#form-newsletter');
const containerCheckbox = document.querySelector('.container-checkbox');

checkboxFooter.addEventListener('change', checkboxStatus);

function checkboxStatus () {
    if(checkboxFooter.checked && grecaptcha && grecaptcha.getResponse().length > 0){
        buttonSubmit.disabled = false; 
    }else {
        buttonSubmit.disabled = true;
    }
} 

const closeToast = document.querySelector('.close-toast');

const divButtonSubmit = document.querySelector('.button-submit');
const tooltip = document.querySelector('.tooltip-button');

 
document.addEventListener('DOMContentLoaded', () => {
    contactForm.addEventListener('mouseenter', () => {checkboxStatus(); });
    formNewsletter.addEventListener('mouseenter', () => {checkboxStatus(); });
    containerCheckbox.addEventListener('mouseenter', () => {checkboxStatus();});
    buttonSubmit.addEventListener('mouseenter', () => {checkboxStatus();});
    checkboxStatus();
});

if (closeToast) {
    const cardsuccess = document.querySelector('.new-card-success');
    const cardError = document.querySelector('.new-card-error');

    //vanish with click
    $(".close-toast").click(function (e) { 
        if(cardsuccess){
            $(".new-card-success").fadeOut(1000, function(){
                //animation complete
                $(".cards-container").empty();
            });
        }

        if(cardError){
            $(".new-card-error").fadeOut(1000, function(){
                //animation complete
                $(".cards-container").empty();
            });
        }
    });

    //vanish with time
    setTimeout(function(){
        if(cardsuccess){
            $(".new-card-success").fadeOut(1000, function(){
                //animation complete
                $(".cards-container").empty();
            });
        }

        if(cardError){
            $(".new-card-error").fadeOut(1000, function(){
                //animation complete
                $(".cards-container").empty();
            });
        }
    }, 5000);
}

divButtonSubmit.addEventListener('mouseenter', () => {
    if (buttonSubmit.disabled) {
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '1';
        return
    }
    tooltip.style.visibility = 'hidden';
    tooltip.style.opacity = '0';
});

divButtonSubmit.addEventListener('mouseleave', () => {
    tooltip.style.visibility = 'hidden';
}); 

